module.exports = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  LOCAL_STORAGE_KEY: process.env.REACT_APP_LOCAL_STORAGE_KEY,
};
